<template>
	<sf-data-table
		ref="dataTable"
		:pageUnit="pagingInfo.pageUnit"
		:totalSize="pagingInfo.totalSize"
		paging
		index
		:columns="columns"
		:rows="rows"
		fit="fit"
		:excel="isButton_(scrId, 'EX')"
		:customExcel="excelFunc"
		@changedPage="changedPage"
	>
	</sf-data-table>
</template>

<script>
import { BASE_URL } from '@/constants';
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '../../store/helpers';

export default {
	props: { scrId: { type: String, default: '' } },
	computed: {
		...rootComputed,
		...serviceComputed,
		rows() {
			return this.resultList;
		},
		columns() {
			return this.getColumns_;
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		async changedPage({ currentPageVal, pageUnitVal, prePage, prePageUnit }) {
			if (!prePage || !prePageUnit) {
				//초기값 셋팅시 이미 searchBar에서 데이터를 조회했기 때문에 중복 조회 하지않도록 처리
				return;
			}
			this.setPagingInfo_({ key: 'currentPage', value: currentPageVal });
			this.setPagingInfo_({ key: 'pageUnit', value: pageUnitVal });
			this.$emit('Refresh');
		},
		excelFunc() {
			//커스텀 엑셀다운로드시 필요한 함수
			const queryStr = this.$sf_objectToQueryString({
				strMt: this.searchParams.strMt /* 발생년월 */
			});

			const url = `${BASE_URL}/pqy/pcku/overSrgCpr/v1/excels${queryStr}`;

			this.$sf_xlsxDown({ url, columns: this.columns }).catch(error => {
				console.log(error);
				this.$sf_toast({ type: 'error', message: error.message });
			});
		}
	}
};
</script>

<style></style>
